

const comp_hero_global = document.getElementById("comp-hero-global");

if (comp_hero_global) {
  const btn_video = comp_hero_global.querySelector(".btn.video") ?? "";
  const btn_gallery = comp_hero_global.querySelector(".btn.gallery") ?? "";

  //% If video button exist add event listener
  btn_video.onclick ??= () => {
    triggerEvent(window, "video_mount");
    // console.log("play video");
  };

  //% If gallery button exist add event listener
  btn_gallery.onclick ??= () => {
    triggerEvent(window, "gallery_mount");
    // console.log("open gallery");
  };
}
